import '../../../common/dashboard/filters/applied/applied_multiple_values_filter_view.js.coffee'
import '../../../common/dashboard/filters/fixed_string_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedFixedStringFilterView extends
Common.Dashboard.Filters.AppliedMultipleValuesFilterView

  initialize: ({filter, isReadOnly}) ->
    super({filter, isReadOnly})
    _.extend(@, Common.Dashboard.Filters.FixedStringFilterMixin)

  _displayTitle: =>
    @filter.getName()

  _seeAll: ->
    @openFixedStringFilterModal()

  modalTitle: ->
    I18n.t 'common.session.filters.fixed_string.modal.applied_title'

  modalSubtitle: ->
    I18n.t 'common.session.filters.fixed_string.modal.applied_subtitle'

  removeValue: ({value}) ->
    @trigger('filter:value:remove', value: value)
